import axios from 'axios'
import { useUserStore } from '../store/userStore'
import { swalAlert } from '../utils/swal/swal'

const SERVER_URL = process.env.REACT_APP_SERVER_URL

export const api = axios.create({
  baseURL: SERVER_URL + '/api',
})

export const authApi = axios.create({
  baseURL: SERVER_URL + '/api',
  withCredentials: true,
}) // authApi로 요청하는 경로는 백엔드에서 authMiddleware를 거쳐야한다.

/* axios 인터셉터 - 토큰검증 및 요청재시도 */
let isRefreshing = false
authApi.interceptors.response.use(
  // 토큰검증 성공
  (response) => {
    return response
  },

  // 토큰검증 실패
  async (error) => {
    const originalRequest = error.config

    if (error.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      if (!isRefreshing) {
        isRefreshing = true

        try {
          await axios.get(SERVER_URL + '/api/auth/refresh', { withCredentials: true }) // refreshToken 검증
          isRefreshing = false

          return authApi(originalRequest) // 요청 재시도

        } catch (refreshError) {
          await axios.get(SERVER_URL + '/api/auth/logout', { withCredentials: true }) // 백엔드 로그아웃 - 토큰 삭제

          const userStoreState = useUserStore.getState()
          userStoreState.logoutAction() // 프론트 로그아웃 - 전역 상태 초기화
          isRefreshing = false

          swalAlert('', '로그인 정보 보호를 위해 자동으로 로그아웃되었습니다.<br/> 다시 로그인 해주세요.', 'info', '확인', () => { window.location.href = '/login' })
          return new Promise(() => { })

          // return Promise.reject(new Error('Refresh token expired. Please log in again.'))
        }
      }
    }

    return Promise.reject(error)
  }
)
